import React, { useEffect } from "react";
import { nanoid } from "@reduxjs/toolkit";
import { useOutletContext } from "react-router-dom";
// component
import InnerLayouts from "@/components/InnerLayouts";
// hooks
import useContent from "@/hooks/useContent";
import useSEO from "@/hooks/useSEO";
// types
import TContent from "./type";
// enums
import TOutletContext from "@/cms/types/TOutletContext";
import { isEmpty } from "lodash";


const Layouts:any = {

    ...InnerLayouts

}

const RenderContent = ( props:any ) => {
    const { webApplicationLanguageISOCode, _showLoader, _hideLoader, _viewEvent } = useOutletContext<TOutletContext>();
    useSEO({ language:webApplicationLanguageISOCode, type:"null", id:props.contentId });

    useEffect (() => { _viewEvent(props.contentId); setTimeout(() => { _hideLoader(); }, 100); return () => { _showLoader(); } }, [props.contentId]);

    return (<props.Layout contentDetailPayload={props.payload} />)
}

const Render = ( props:any ) => {
    const contentDetails = useContent({ unqKey:props.unqKey, id:props.contentId });

    if ( !contentDetails || isEmpty(contentDetails) ) return null;

    const layoutName = contentDetails.layouts[0]?.layoutName;
    let Layout:any = Layouts?.[layoutName];

    if ( !Layout ) return null;

    return (<RenderContent contentId={props.contentId} payload={contentDetails} Layout={Layout} />)
}

const Content = ( props:TContent ) => {
    const { contentId, _showLoader } = useOutletContext<TOutletContext>();
    const unqKey = contentId?.split("-")?.[4];

    useEffect (
        () => { 
            const navbarInterval = setInterval(
                () => {
                    const element = document.getElementsByClassName("dark-navbar")?.[0];
                    if ( element ) {
                        element.classList.remove("dark-navbar");
                        element.classList.add("navbar-style-2");
                        clearInterval(navbarInterval);
                    }
                },500
            )
            return () => { _showLoader(); } 
        }, []
    )

    if ( !unqKey || isEmpty(unqKey) ) return null;

    return (<Render contentId={contentId} unqKey={unqKey} />)
}

export default Content;
